import {Injectable} from '@angular/core';
import {Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';
import {Question} from 'shared/models/questions/question';

@Injectable()
export class TreeListRepository {

  constructor(private http: Http) { }

  public getRootQuestions(): Observable<Array<Question>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.questionChains}/rootquestions`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public deleteTree(id: string): Observable<Response> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.delete(`${environment.questionChains}/${id}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dynamic-tips/tree-list/repositories/tree-list.repository.ts